import { create } from 'zustand'

const useCustomerJourneyStore = create((set) => ({
  user_info: {
    isLoading: true,
  },
  emotions: {
    isLoading: true,
  },
  opportunities_and_painpoints: [
    {
      isLoading: true,
    },
    {
      isLoading: true,
    },
    {
      isLoading: true,
    },
    {
      isLoading: true,
    },
    {
      isLoading: true,
    },
  ],
  journeys: {
    events: [
      {
        action: [],
        isLoading: true,
      },
      {
        action: [],
        isLoading: true,
      },
      {
        action: [],
        isLoading: true,
      },
      {
        action: [],
        isLoading: true,
      },
      {
        action: [],
        isLoading: true,
      },
    ],
  },
  setField: (field, value) => set((state) => ({ ...state, [field]: value })),
  updateUserInfo: (field, value) =>
    set((state) => ({
      ...state,
      user_info: {
        ...state.user_info,
        [field]: value,
      },
    })),
  updateOAC: (index, field, value) =>
    set((state) => ({
      ...state,
      opportunities_and_painpoints: {
        opportunities_and_painpoints:
          state.opportunities_and_painpoints.opportunities_and_painpoints.map(
            (item, i) =>
              i === index
                ? {
                    ...item,
                    [field]: value,
                  }
                : item
          ),
      },
    })),
  updateJourneys: (index, field, value) =>
    set((state) => ({
      ...state,
      journeys: {
        events: state.journeys.events.map((item, i) =>
          i === index
            ? {
                ...item,
                [field]: value,
              }
            : item
        ),
      },
    })),
  updateEmotions: (value) =>
    set((state) => ({
      ...state,
      emotions: {
        emotions: value,
      },
    })),
  init: () =>
    set((state) => ({
      ...state,
      user_info: {
        isLoading: true,
      },
      emotions: {
        isLoading: true,
      },
      opportunities_and_painpoints: {
        opportunities_and_painpoints: [
          {
            isLoading: true,
          },
          {
            isLoading: true,
          },
          {
            isLoading: true,
          },
          {
            isLoading: true,
          },
          {
            isLoading: true,
          },
        ],
      },
      journeys: {
        events: [
          {
            action: [],
            isLoading: true,
          },
          {
            action: [],
            isLoading: true,
          },
          {
            action: [],
            isLoading: true,
          },
          {
            action: [],
            isLoading: true,
          },
          {
            action: [],
            isLoading: true,
          },
        ],
      },
    })),
}))

export default useCustomerJourneyStore
